import * as types from "./types";

const mutations = {
    [types.LOADING_EMAILCAMPAIGN](state, value) {
        state.loading = value;
    },
    [types.GET_EMAILCAMPAIGN_LIST](state, emailcampaign) {
        state.emailcampaign = emailcampaign;
    },
    [types.REMOVE_EMAILCAMPAIGN](state, id) {        
        state.emailcampaign = state.emailcampaign.filter((x) => x.id !== id);        
    },
    [types.ADD_EMAILCAMPAIGN](state, emailcampaign) {        
        state.emailcampaign.unshift(emailcampaign);
    },
    [types.UPDATE_EMAILCAMPAIGN](state, emailcampaign) {        
        const TemplateIndex = state.emailcampaign.findIndex((x) => x.id === emailcampaign.id);
        state.emailcampaign[TemplateIndex] = emailcampaign;        
    },
    [types.UPDATE_EMAILCAMPAIGN_STATUS](state, { id, status }) {
        const campaign = state.emailcampaign.find((x) => x.id === id);
        if (campaign) {
            campaign.status = status;
        }
    },

    
    [types.GET_EMAILCAMPAIGNID](state, id) {
        state.emailcampaignid = id;
    }
};

export default mutations;